import AbhishekImage from '../assets/Abhishek.png'
import AriakaImage from '../assets/Ariaka.png'
import VedantImage from '../assets/Vedant.png'

export const feedBackData = [
  {
    id: '1',
    name: 'Vedant Jain',
    content:
      'Joining Devsnest was one of the best decisions I have made so far. Devsnest made me the Engineer I always wanted to be.',
    profile_url: VedantImage.src,
    designation: 'SDE-2, Disney+HotStar'
  },
  {
    id: '2',
    name: 'Araika Singh',
    content:
      'Devsnest provided such a community which helped me to grew more accountable. It made learning more fun.',
    profile_url: AriakaImage.src,
    designation: 'SWE @Visa'
  },
  {
    id: '3',
    name: 'Abhishek Saran',
    content:
      'Devsnest provided such a community which helped me to grew more accountable. It made learning more fun.',
    profile_url: AbhishekImage.src,
    designation: 'DevOps Engineer at Zoom'
  }
]
